import { openDB } from 'idb';

const DB_VERSION = 1;
const _dbPromises = {};
let _dbPrefix = null;

function getDbPrefix() {
  if (!_dbPrefix) {
    _dbPrefix = 'cheforga' + process.env.VUE_APP_APIROOTURL
      .replace(/^https?:\/\//, '')
      .replace(/\//g, '');
  }
  return _dbPrefix;
}

export function getDbName(tableName) {
  return getDbPrefix() + tableName;
}

function getDb(tableName) {
  if (!_dbPromises[tableName]) {
    _dbPromises[tableName] = openDB(getDbName(tableName), DB_VERSION, {
      upgrade(db) {
        const store = db.createObjectStore(tableName, { keyPath: 'id' });
        store.createIndex('modifiedAt', 'modifiedAt');
      },
    });
  }
  return _dbPromises[tableName];
}

function sanitizeItem(item) {
  if (item && item.data && typeof item.data === 'object') {
    delete item.data.isLoading;
  }
  return item;
}

const idbCache = {
  getDbName,

  async getAll(tableName) {
    const db = await getDb(tableName);
    return db.getAll(tableName);
  },

  async get(tableName, id) {
    const db = await getDb(tableName);
    return db.get(tableName, id);
  },

  async put(tableName, item) {
    const db = await getDb(tableName);
    return db.put(tableName, sanitizeItem(item));
  },

  async delete(tableName, id) {
    const db = await getDb(tableName);
    return db.delete(tableName, id);
  },

  async putAll(tableName, items) {
    const db = await getDb(tableName);
    const tx = db.transaction(tableName, 'readwrite');
    for (const item of items) {
      tx.store.put(sanitizeItem(item));
    }
    await tx.done;
  },

  async replaceAll(tableName, items) {
    const db = await getDb(tableName);
    const tx = db.transaction(tableName, 'readwrite');
    tx.store.clear();
    for (const item of items) {
      tx.store.put(sanitizeItem(item));
    }
    await tx.done;
  },

  async clear(tableName) {
    const db = await getDb(tableName);
    return db.clear(tableName);
  },
};

export default idbCache;
